import { Paper, Stack, SvgIconProps, Typography } from '@mui/material'
import React from 'react'

interface Props {
  Icon: (props: SvgIconProps) => React.ReactElement
  label: string
  value: string
}

export const Card: React.FC<Props> = ({ Icon, label, value }) => {
  return (
    <Paper sx={theme => ({ p: 2.5, minWidth: 220, borderRadius: theme.shape.borderRadius })}>
      <Stack direction="row" spacing={2} alignItems="center">
        <Icon
          sx={{
            color: theme => theme.palette.primary.dark,
            fontSize: 48,
          }}
        />

        <Stack gap={0.5}>
          <Typography variant="body2">{label}</Typography>
          <Typography
            sx={{
              fontSize: 24,
              fontWeight: 'bold',
            }}
          >
            {value}
          </Typography>
        </Stack>
      </Stack>
    </Paper>
  )
}
